import { TweenMax } from 'gsap';
import { useEffect } from 'react';
import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EcoVideo from 'eco-design/base/eco-video';

export default function C() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.C');

    useEffect(() => {
        const ScrollMagic = window.ScrollMagic;
        if (!ScrollMagic) return;
    }, []);

    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1080;
        const ScrollMagic = window.ScrollMagic;
        if (!ScrollMagic) return;

        const controller = new ScrollMagic.Controller({});

        new ScrollMagic.Scene({
            triggerElement: '.power-ocean-home-C',
            offset: layoutH * 1,
            triggerHook: 1,
            duration: layoutH * 2.4,
        })
            .setTween(
                TweenMax.fromTo(
                    '.power-ocean-home-C .text-words',
                    0.5,
                    {
                        scale: 1,
                        transformOrigin: '50% 50%',
                    },
                    {
                        scale: 20,
                    },
                ),
            )
            .addTo(controller);

        const AniContainer = window?.AniContainer;
        AniContainer.create({
            syncFromTo: [['.power-ocean-home-C .text-banner', { opacity: 1 }, { opacity: 0 }]],
            triggerElement: '.power-ocean-home-C',
            triggerHook: 1,
            duration: '20%',
            offset: '230%',
            scrollUpdatePos: true,
        });

        AniContainer.create({
            asyncFromTo: [
                ['.power-ocean-home-C .text1 .desc', { opacity: 0, y: layoutH / 2 - 120 }, { opacity: 1, y: 0 }, 0.6],
                ['.power-ocean-home-C .text1 .desc', { opacity: 1, y: 0 }, { opacity: 0, y: -layoutH / 2 + 120 }, 0.6],
                ['.power-ocean-home-C .text2 .desc', { opacity: 0, y: layoutH / 2 - 120 }, { opacity: 1, y: 0 }, 0.6],
                ['.power-ocean-home-C .text2 .desc', { opacity: 1, y: 0 }, { opacity: 0, y: -layoutH / 2 + 120 }, 0.6],
                ['.power-ocean-home-C .text3 .desc', { opacity: 0, y: layoutH / 2 - 120 }, { opacity: 1, y: 0 }, 0.6],
                ['.power-ocean-home-C .text3 .desc', { opacity: 1, y: 0 }, { opacity: 0, y: -layoutH / 2 + 120 }, 0.6],
                ['.power-ocean-home-C .text4 .desc', { opacity: 0, y: layoutH / 2 - 120 }, { opacity: 1, y: 0 }, 0.5],
            ],
            asyncTimeLine: [0, 1, 1.5, 2.5, 3, 4, 4.5],
            triggerElement: '.power-ocean-home-C',
            triggerHook: 1,
            duration: '350%',
            offset: layoutH * 3.5,
            scrollUpdatePos: true,
        });

        setTimeout(() => {
            const videoEl = document.querySelector('.power-ocean-home-C .video-box video') as HTMLVideoElement;
            AniContainer.create({
                triggerElement: '.power-ocean-home-C',
                triggerHook: 1,
                offset: '250%',
                duraton: '500%',
                scrollUpdatePos: true,
                onEnter: () => {
                    if (videoEl) {
                        videoEl.currentTime = 0;
                        videoEl.play();
                    }
                },
                onLeave: () => {
                    if (videoEl) {
                        videoEl.pause();
                        videoEl.currentTime = 0;
                    }
                },
            });
        }, 500);
    }, []);

    return (
        <div className={`power-ocean-home-C ${styles['power-ocean-home-C']}`}>
            <div className="sec3">
                <div className="sticky">
                    <div className="text-scale">
                        <div className="text-banner">
                            <h3 className="text-words">{t('title')}</h3>
                        </div>
                    </div>
                    <div className="inner-box">
                        <div className="video-box">
                            <EcoVideo
                                className="video fullImgs"
                                pc={'https://websiteoss.ecoflow.com/upload/video/1768889612386/3.mp4'}
                                // autoPlay={false}
                                autoPlay
                                loop
                                aria-label={t`Flexible investment`}
                            />
                        </div>
                        <div className="text-box">
                            <div className="text1 text">
                                <h3 className="desc"> {t('desc1')}</h3>
                            </div>
                            <div className="text2 text">
                                <h3 className="desc"> {t('desc2')}</h3>
                            </div>
                            <div className="text3 text">
                                <h3 className="desc"> {t('desc3')}</h3>
                            </div>
                            <div className="text4 text">
                                <div className="text4-inner">
                                    <h3 className="desc"> {t('desc4')}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
